import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuthStore } from '../stores/auth.store';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const setAuth = useAuthStore((s) => s.setAuth);
  const navigate = useNavigate();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setAuth(data.user, data.token, data.expiresAt);
      navigate('/topics', { replace: true });
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { error?: string } } }).response?.data?.error
                  ?? 'Ошибка входа';
      setError(msg);
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <form onSubmit={onSubmit} className="card-glass p-8 w-full max-w-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white text-lg shadow-[0_8px_25px_rgba(79,70,229,0.4)]">
            ▶
          </div>
          <div>
            <h1 className="text-xl font-bold tracking-tight">HeyGen Factory</h1>
            <p className="text-xs text-slate-500">Вход в панель</p>
          </div>
        </div>

        <label className="block text-xs uppercase tracking-wider text-slate-500 font-semibold mb-2">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          className="input mb-4"
        />

        <label className="block text-xs uppercase tracking-wider text-slate-500 font-semibold mb-2">Пароль</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          className="input mb-4"
        />

        {error && (
          <p className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-xl p-3 mb-4" role="alert">
            {error}
          </p>
        )}

        <button type="submit" disabled={loading} className="btn btn-lg btn-primary w-full">
          {loading ? '⏳ Вход…' : '→ Войти'}
        </button>
      </form>
    </div>
  );
}
